import {
  Avatar, Checkbox, List, ListItem, ListItemAvatar, ListItemText, Stack, Typography
} from '@mui/material';
import {
  addUserToPoints, pointsNextStepExpanded, pointsPreviousStep, removeUserFromPoints
} from '../../../actions/points';
import { generateMatches, numberOfMatches } from '../../../domain/matchSchedule';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import StepActions from './StepActions';

export default function Step1() {
  const dispatch = useAppDispatch();
  const { users, usersPoints } = useAppSelector((s) => s.points);
  const selected = new Set(usersPoints.map((p) => p._id));

  return (
    <Stack className="step1" spacing={2} alignItems="flex-start">
      <Typography variant="h6">Wybierz osoby</Typography>
      <Typography variant="body2" color="text.secondary">
        {usersPoints.length} obecnych, {numberOfMatches(usersPoints.length)} meczów
      </Typography>
      <List dense sx={{ width: '100%', maxWidth: 420 }}>
        {users.map((user) => (
          <ListItem
            key={user._id}
            disableGutters
            secondaryAction={
              <Avatar sx={{ width: 32, height: 32 }}>{user.name.slice(0, 1).toUpperCase()}</Avatar>
            }
          >
            <ListItemAvatar sx={{ minWidth: 42 }}>
              <Checkbox
                edge="start"
                checked={selected.has(user._id)}
                onChange={(_event, checked) => dispatch(
                  checked ? addUserToPoints(user) : removeUserFromPoints(user)
                )}
              />
            </ListItemAvatar>
            <ListItemText primary={user.name} />
          </ListItem>
        ))}
      </List>
      <StepActions
        onBack={() => dispatch(pointsPreviousStep())}
        onNext={() => dispatch(pointsNextStepExpanded(generateMatches(usersPoints)))}
        nextDisabled={usersPoints.length <= 1}
      />
    </Stack>
  );
}
